export enum DocumentType {
    Invoice = 0,
    DeliverySchedule = 1
}

export const DocumentTypeMetadata = {
    '0': {
        display: 'Invoice',
        value: 0
    },
    '1': {
        display: 'Delivery Schedule',
        value: 1
    },
    '2': {
        display: 'RS Order Acknowledgement',
        value: 2
    },
    '3': {
        display: 'CD Order Acknowledgement',
        value: 2
    }
};
